import { useEffect } from 'react';
import { useBlocker } from 'react-router-dom'


// Hook personnalisé pour afficher un avertissement lors de la navigation
function usePrompt(message, when) {
  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (e) => {
      if (when) {
        e.preventDefault();
        e.returnValue = message; // Standard pour la plupart des navigateurs
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [when, message]);
}


function Prompt({ when, message }) {
    useBlocker(() => {
        if (when) {
            return ! window.confirm(message)
        }
        return false
    }, [when])

  return <div key={when} />
}

export { Prompt, usePrompt };
